export const browser = false;
export const dev = __SVELTEKIT_DEV__;
export const version = __SVELTEKIT_APP_VERSION__;
export let building = false;

export let prerendering = false;

export function set_building() {
	building = true;
}

export function set_prerendering() {
	prerendering = true;
}
